import { toast } from '@shared/hooks/useToast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router'
import * as authService from '../service/auth.service'
import { useAuthStore } from './useAuthStore'

export function useLogout() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { logout: logoutStore } = useAuthStore()

  const completeLogout = () => {
    logoutStore()
    queryClient.clear()
    navigate('/login')
  }
  const mutation = useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      completeLogout()
      toast({
        title: 'Logout realizado',
        description: 'Você foi desconectado do sistema',
      })
    },
    onError: () => {
      // Mesmo com erro no backend, fazer logout local
      completeLogout()
    },
  })
  return { ...mutation, completeLogout }
}
